import styled from "@emotion/styled";
import React from "react";
import { useNavigate } from "react-router-dom";
import { APP_BREAKPOINT } from "src/constants/layout";
import Path from "src/constants/path";
import { createAppPath } from "src/lib/createAppPath";
import translate from "src/lib/translate";
import { IconProfile } from "src/constants/icons";

const Wrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 0.2rem 0 1.3rem;
`;

const CircleButton = styled.button`
  background: var(--Secondary-Dark-Cream, #f2efe7);
  border-radius: 50%;
  aspect-ratio: 1;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: var(--Secondary-Cream, #e9e5da);
  }

  &:active {
    background: var(--Secondary-Dark-Cream-Pressed, #dedad0);
    transform: scale(0.95);
  }

  &:focus-visible {
    outline: 2px solid var(--Accessible-Blue, #3973da);
    outline-offset: 2px;
  }
`;

const TriggerArea = styled.div`
  position: absolute;
  inset: -1rem;
`;

const ProfileWidget = () => {
  const showWidget = window.innerWidth <= APP_BREAKPOINT;
  const navigate = useNavigate();

  if (!showWidget) {
    return null;
  }

  return (
    <Wrap>
      <CircleButton
        onClick={() => navigate(createAppPath(Path.profile))}
        aria-label={translate("profile.aria.label")}
        title={translate("nav_profile")}
      >
        <TriggerArea />
        <IconProfile />
      </CircleButton>
    </Wrap>
  );
};

export default ProfileWidget;
